import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Avatar from '../Assetes/Images/avatar.svg';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import Delivery from '../Views/OrderOptions/Delivery';
import PickUp from '../Views/OrderOptions/PickUp';
import { useTranslation } from 'react-i18next';

export default function SelectStoreModal(props: any) {
    const { t } = useTranslation();

    return (
        <Modal className='track-modal' show={props.show} onHide={props.handleClose} backdrop={"static"} centered>
            <div className='modal-design'>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <Modal.Header className='justify-content-center' closeButton>
                <Modal.Title><h5>{t("SELECT_ORDER_CHANNEL")}</h5></Modal.Title>
            </Modal.Header>
            <Modal.Body className='w-100 delivery-order text-center p-4'>
                <div className='order-options justify-content-center'>
                    {process.env.REACT_APP_DELIVERY_ENABLE == "true" && <Delivery handleSelectStoreClose={props.handleClose}/>}
                    <PickUp handleSelectStoreClose={props.handleClose}/>
                </div>
            </Modal.Body>
        </Modal>
    )
}
